import { LabelInValue } from "@/types/ASelect";

export const buildLabelInValue = (): LabelInValue => ({
  key: "",
  label: "",
});
